export default "__VITE_ASSET__59776138__"